
































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { InputValidation } from '../../../helpers/inputValidation';
import { Format } from '@models';
import CampaignService from 'services/CampaignService';

@Component
export default class CampaignBannerSelector extends Vue {
  name = 'campaign-banner-selector';

  @Prop(String) id!: string;
  @Prop(Function) onError: any;

  @Prop({ type: String, default: "" })
  placeholderId: string;

  @Prop({ type: String, default: "" })
  formatIdIncluded: string;

  @Prop({ type: Object as () => Format }) value: Format;

  @Prop({ type: Boolean, default: false }) isLoading: boolean;

  @Prop({ type: Array as () => Format[] }) banners: Format[];


  options: Format[] = [];
  optionsMax: number = 249;

  input = InputValidation;
  campaignService = CampaignService;


  onSelectionMenuClosed(value, id) {
    const rules = this.$refs.inputComponent.rules;
    this.$refs.inputComponent.validate(rules);
  }

  bindValue() {
    if (this.value == undefined) {
      let lastSavedBannerId = localStorage.getItem("LastSavedBannerId");
      if (lastSavedBannerId) {
        var lastSavedBanner = this.options.find(c => c.id === lastSavedBannerId);
        this.updateValue(lastSavedBanner);
      }
    }

    return this.value;
  }

  updateValue(value: Format) {
    this.$emit('input', value)
  }

  @Watch('banners')
  updateOptions() {
    if (this.banners && this.banners.length > 0) {
      this.options = this.banners;
    } else {
      this.options = [];
    }
  }

  asyncFindBanners(query) {
    this.isLoading = true;
    this.options = this.banners.filter(c => c.displayTitle.toLowerCase().includes(query.toLowerCase()));
    this.isLoading = false;
  }

  bannerFilterTaglimitText(count) {
    return `and ${count} other items`
  }
}
